import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector,reset } from "redux-form";

import {  Card, CardBody, Button, Spinner, CardTitle,Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from "react-redux";
import Banner from "../common/banner";
import {renderCheckbox} from "../common/renderinput"
import axios from "axios";
import appConfig from '../../config/config';
import { Link } from "react-router-dom/cjs/react-router-dom";

const divStyle = {
    backgroundColor: '#fff'
};
const padStyle = {
    paddingTop: '5px', paddingLeft : '0px'
};
const diagStyle = {
    width: '897px', height:'802px'
}
class OrderNoteForm extends Component {

    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: '', activeTab: '1', 
            Loading: false, 
            data: [], display:true, 
            isSuccess:false
        };
        console.log(this.props)
    }
    closeBanner = () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    toggle = (val) => {
        this.setState({...this.state, display : !val})
    }
    submit = (values) => {
      this.setState({...this.state, Loading : true})
        axios.post(
            appConfig.apiGateway.updateOrderUrl,
            JSON.stringify({
                ...values, OrderId: this.props.OrderId,
                OrderProductId: this.props.OrderProductId,
                Action: "AddNote",
                UserName: this.props.session.session.user.name
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => { 
                  this.setState({...this.state, Loading : false})
                if (!(response.hasOwnProperty('data') && response.data.hasOwnProperty('body')))
                {
                    this.setState({ ...this.state, message: 'Invalid response', 
                    showBanner: true })
                    return;
                }
                //var myObject = JSON.parse(response.data.body);
                if (response.data.body.status) {
                    this.props.dispatch(reset('orderNoteForm'))
                    this.props.showBanner(true,response.data.body.message)
                    this.props.Add(false)
                    return;
                }
                else {
                    this.setState(state => ({ ...state, message: response.data.body.message, 
                      showBanner: true }));
                }

            },
            (error) => {
                this.setState(state => ({ ...state, message: error, showBanner: true, Loading : false }));

            });
       
    }
    componentDidMount() {
    }
    renderInput = ({ input, label, meta }) => {
        const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
        return (
            <div className="form-group">
                <textarea {...input} autoComplete="new-password" rows="4" className={className} placeholder={label} />
                <div className="invalid-feedback">{meta.error}</div>
            </div>
        );
    };
    render() {

        return (
          <>
            <div>
              <Modal
                isOpen={this.state.display}
                toggle={this.toggle}
                contentClassName="custom-modal-style"
              >
                <form
                  onSubmit={this.props.handleSubmit(this.submit)}
                  style={{ marginLeft: "0%", marginRight: "5%" }}
                >
                  <ModalHeader>Add Note</ModalHeader>
                  <ModalBody>
                    {this.state.showBanner && (
                      <Banner
                        Close={this.closeBanner}
                        message={this.state.message}
                        IsSuccess={this.state.isSuccess}
                      />
                    )}
                    <div className="form-row col-12" style={padStyle}>
                      <div className="col-12" style={divStyle}>
                        <Field
                          name="Note"
                          component={this.renderInput}
                          label="Note"
                        />
                      </div>
                      <div className="col-12" style={divStyle}>
                        <Field
                          name="SendToClient"
                          component={renderCheckbox}
                          label="Send To Client"
                          isLabel="true"
                        />
                      </div>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" type="submit">
                      {this.state.Loading && <Spinner />}
                      {!this.state.Loading && <span>Save</span>}
                    </Button>
                    <Link to={{ pathname: "/order-search" }}>
                      <Button color="secondary">Cancel</Button>
                    </Link>

                  </ModalFooter>
                </form>
              </Modal>
            </div>
          </>
        );
    }

}
const validate = (formValues) => {
    const errors = {};
    if (!formValues.Note) {
        errors.Note = "Please add note ";
    }
    return errors;
}
var orderNoteform = reduxForm({
    form: 'orderNoteForm',
    validate
})(OrderNoteForm);

orderNoteform = connect(
    state => ({
        session: state.session
    })
)(orderNoteform);

export default orderNoteform;